export default __webpack_public_path__ + "static/media/ofs_700_jacket.112dfe4a.jpg";